// extracted by mini-css-extract-plugin
module.exports = {"techWorkMessage":"ContactInfoForm_techWorkMessage__sPDkF"};